var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntersexualRedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mujeres",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8004",
    "data-name": "Rectangle 8004",
    width: 60,
    height: 60,
    fill: "#fdf4f4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8003",
    "data-name": "Rectangle 8003",
    width: 60,
    height: 60,
    fill: "#c0e4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8002",
    "data-name": "Rectangle 8002",
    width: 59,
    height: 59,
    transform: "translate(0.562 0.178)",
    fill: "#f6d5d5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8116",
    "data-name": "Rectangle 8116",
    width: 26,
    height: 38,
    transform: "translate(-0.392 -0.089)",
    fill: "#d1484b",
    stroke: "#d1484b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8116-2",
    "data-name": "Rectangle 8116",
    width: 22.856,
    height: 33.405,
    fill: "#1c5866",
    stroke: "#d1484b",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8940",
    "data-name": "Group 8940",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8939",
    "data-name": "Group 8939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8938",
    "data-name": "Group 8938",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8937",
    "data-name": "Group 8937",
    opacity: 0.996,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8936",
    "data-name": "Group 8936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8935",
    "data-name": "Group 8935",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21867",
    "data-name": "Path 21867",
    d: "M30.062.178a29.5,29.5,0,1,1-29.5,29.5,29.5,29.5,0,0,1,29.5-29.5",
    fill: "#f6d5d5"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10866",
    "data-name": "Group 10866",
    transform: "translate(17.392 10.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9023",
    "data-name": "Group 9023",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11033",
    "data-name": "Group 11033",
    transform: "translate(1.572 2.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9023-2",
    "data-name": "Group 9023",
    transform: "translate(-0.392 -0.089)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11032",
    "data-name": "Group 11032",
    transform: "translate(1.339 1.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    transform: "translate(0 4.824)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.008,
    cy: 8.008,
    r: 8.008,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.008,
    cy: 8.008,
    r: 6.758,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24043",
    "data-name": "Path 24043",
    d: "M-15406.864,1301.325l-4.927,4.927",
    transform: "translate(15425.581 -1298.513)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24044",
    "data-name": "Path 24044",
    d: "M4.926,0,0,4.927",
    transform: "translate(7.978 22.633) rotate(45)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24045",
    "data-name": "Path 24045",
    d: "M6.675,0,0,6.675",
    transform: "translate(3.258 24.881) rotate(-45)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24046",
    "data-name": "Path 24046",
    d: "M0,3.3,3.3,0l3.3,3.3",
    transform: "translate(16.843 0) rotate(45)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersexualRedIcon);
export default __webpack_public_path__ + "static/media/intersexual_red_icon.a8b70dd1f7748c5b90a2411748f56938.svg";
export { ForwardRef as ReactComponent };